import React from 'react'
import style from './LinksThePages.module.scss'
import {Link} from 'react-router-dom'

import LinksImage1 from '../../assets/LinksImage1.png'
import LinksImage2 from '../../assets/LinksImage2.png'
import LinksImage3 from '../../assets/LinksImage3.png'
import LinksImage4 from '../../assets/LinksImage4.png'
import LinksImage5 from '../../assets/LinksImage5.png'
import LinksImage6 from '../../assets/LinksImage6.png'

export default function LinksThePages({setActiveCategory}) {
    return (
        <div className='containerLinks'>
            <div className={style.linksBox}>
                <Link onClick={() => setActiveCategory('corporatePractice')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage1} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>Корпоративная практика</p>
                        <svg className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
                <Link onClick={() => setActiveCategory('transactions')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage2} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>M&A</p>
                        <svg  className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
                <Link onClick={() => setActiveCategory('public-privatePartnership')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage3} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>ГЧП</p>
                        <svg className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
                <Link onClick={() => setActiveCategory('internationalPractice')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage4} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>Международная практика</p>
                        <svg className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
                <Link onClick={() => setActiveCategory('specialAssignments')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage5} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>Особые поручения</p>
                        <svg className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
                <Link onClick={() => setActiveCategory('contacts')} className={style.link} to="/services">
                    <img className={style.image} src={LinksImage6} alt=""/>
                    <div className={style.textContainer}>
                        <p className={style.text}>Контакты</p>
                        <svg className={style.arrow} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="vuesax/linear/arrow-right">
                                <g id="vuesax/linear/arrow-right_2">
                                    <g id="arrow-right">
                                        <path id="Vector" d="M19.5732 8.57324L27.6666 16.6666L19.5732 24.7599"
                                              stroke="white" strokeMiterlimit="10" strokeLinecap="round"
                                              strokeLinejoin="round"/>
                                        <path id="Vector_2" d="M5 16.6666H27.44" stroke="white" strokeMiterlimit="10"
                                              strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </Link>
            </div>
        </div>
    )
}
